/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface DeletePatientInstructionAttachment$Params {
  attachmentID?: number;
}

export function DeletePatientInstructionAttachment(http: HttpClient, rootUrl: string, params?: DeletePatientInstructionAttachment$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, DeletePatientInstructionAttachment.PATH, 'post');
  if (params) {
    rb.query('attachmentID', params.attachmentID, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

DeletePatientInstructionAttachment.PATH = '/api/Supervisor/DeletePatientInstructionAttachment';
